const extraConditions = {
    'date_of_birth': 'dob-day'
}

function findField(_vm, key) {
    return {
        field: _vm.$validator.fields.find({ name: extraConditions[key] ? extraConditions[key] : key, scope: _vm.$options.scope }),
        isExtraCondition: extraConditions[key] ? extraConditions[key] : false 
    };
}

/**
 * Handles errors from backend and atatches them to a field if possible.
 * - Must be in scope of Vue instance (this).
 * @param {Object} errs Field to message dict.
 */
export const handleErrors = (_vm, errs) => {
    Object.keys(errs).forEach(key => {
        const msg = errs[key];
        const { field, isExtraCondition } = findField(_vm, key);

        if (field) {
            _vm.errors.add({ id: field.id, field: isExtraCondition ? isExtraCondition : key, msg, scope: _vm.$options.scope });

            !isExtraCondition && field.setFlags({
                invalid: true,
                valid: false,
                validated: true,
            });
        }
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/outerErrors.js